import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { useIsMobile } from "../../Hooks";

import useStyles from "./FmBasicModal.style";
import { StyledProps } from "@mui/styles";
import { FmMobileHeader } from "..";

interface FmBasicModalProps {
  img: any;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  contentStyle?: any;
}

const FmBasicModal = ({ img, onClose, isOpen, children, contentStyle }: FmBasicModalProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();

  const DesktopStyle = {
    content: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "1068px",
      padding: "32px 64px 32px 32px",
      backgroundColor: "#FFFFFF",
      borderRadius: "20px",
      boxShadow: "0 1px 8px 0 rgba(0,0,0,0.37)",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000,
    },
    overlay: { zIndex: 10000, background: "rgba(0,0,0,.65)" },
  };

  const MobileStyle = {
    content: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100vh",
      padding: "0px",
      backgroundColor: "#FFFFFF",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1000,
    },
    overlay: { zIndex: 10000 },
  };

  const handleClose = () => {
    onClose && onClose();
  };

  const modalStyle = isMobile ? MobileStyle : DesktopStyle;

  return (
    <Modal isOpen={isOpen} onRequestClose={handleClose} style={modalStyle} ariaHideApp={false}>
      <div className={classes.close_container} onClick={handleClose}>
        <img src="/multi-match/assets/remove.png" width="18px" />
      </div>
      {!isMobile && (
        <div className={classes.leftSide}>
          <img src={img} />
        </div>
      )}
      <div className={isMobile ? classes.mobile_rightSide : contentStyle ? contentStyle : classes.rightSide}>
        {isMobile && <FmMobileHeader />}
        {children}
      </div>
    </Modal>
  );
};

export default FmBasicModal;
